module.exports = __webpack_public_path__ + "img/2nd-child-1-min.9241dedd.jpg";